import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconTick from 'components/icons/iconTick';
import JBImage from 'components/essentials/JBImage';
import useScreen from 'hooks/useScreen';
import getOrientationOptionIcon from '../helpers/getOrientationOptionIcon';
const PDPFullWidthImageAndTextOption = t0 => {
  const $ = _c(43);
  const {
    content: t1,
    onClickAction,
    onHoverAction,
    valueId,
    sku,
    optionValueName: t2,
    selectedId
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const content = t3;
  const optionValueName = t2 === undefined ? "" : t2;
  const {
    isMobile
  } = useScreen();
  const location = useLocation();
  let t4;
  if ($[2] !== location.pathname || $[3] !== optionValueName || $[4] !== sku) {
    t4 = getOrientationOptionIcon(optionValueName, sku, location.pathname);
    $[2] = location.pathname;
    $[3] = optionValueName;
    $[4] = sku;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const {
    image: t5,
    customItem: t6
  } = t4;
  const image = t5 === undefined ? null : t5;
  const customItem = t6 === undefined ? null : t6;
  const isSelected = selectedId === valueId;
  const t7 = !isSelected;
  let t8;
  if ($[6] !== isSelected || $[7] !== t7) {
    t8 = classNames("[background:none] w-full flex flex-row border border-solid border-white relative hover:cursor-pointer", {
      "shadow-[inset_0_0_0_2px_#424242,inset_0_0_0_4px_#fff]": isSelected,
      "hover:border-gray-dark": t7,
      "hover:border-white": isSelected
    });
    $[6] = isSelected;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== isMobile || $[10] !== onClickAction || $[11] !== onHoverAction || $[12] !== valueId) {
    t9 = () => {
      if (isMobile) {
        onHoverAction(true, valueId);
      }
      onClickAction(valueId);
    };
    $[9] = isMobile;
    $[10] = onClickAction;
    $[11] = onHoverAction;
    $[12] = valueId;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== isMobile || $[15] !== onHoverAction || $[16] !== valueId) {
    t10 = !isMobile ? () => onHoverAction(true, valueId) : null;
    $[14] = isMobile;
    $[15] = onHoverAction;
    $[16] = valueId;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== isMobile || $[19] !== onHoverAction || $[20] !== valueId) {
    t11 = !isMobile ? () => onHoverAction(false, valueId) : null;
    $[18] = isMobile;
    $[19] = onHoverAction;
    $[20] = valueId;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== content.image || $[23] !== customItem || $[24] !== image) {
    t12 = content.image ? <div key={content.image}>{!customItem ? <JBImage src={image || content.image} size="25vw" /> : customItem}</div> : null;
    $[22] = content.image;
    $[23] = customItem;
    $[24] = image;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== content.text || $[27] !== content.textTitle) {
    t13 = content.textTitle ? <div className="flex-1 text-left [&_span]:block" key={content.textTitle}><span className="text-base text-gray font-bold pt-[.8rem] pr-0 pb-0 pl-[.3rem]">{content.textTitle}</span><span className="text-sm font-bold text-gray-light2">{content.text}</span></div> : null;
    $[26] = content.text;
    $[27] = content.textTitle;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== content.price || $[30] !== isSelected) {
    t14 = content.price && !isSelected ? <div className="text-right pt-[.8rem] pr-4 pb-0 pl-0" key={content.price}>{content.price}</div> : null;
    $[29] = content.price;
    $[30] = isSelected;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== isSelected) {
    t15 = isSelected && <div className={classNames("z-[3001]", {
      "items-center bg-gray-dark flex h-6 justify-center absolute right-[calc(1rem_-_15px)] top-[calc(1rem_-_15px)] w-6 rounded-none md:rounded-tr": isSelected,
      "[&_svg]:h-3.5 [&_svg]:w-3.5": isSelected,
      "[&_svg_path]:fill-white [&_svg_path]:stroke-white": isSelected
    })}><IconTick height="22px" width="22px" /></div>;
    $[32] = isSelected;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t10 || $[35] !== t11 || $[36] !== t12 || $[37] !== t13 || $[38] !== t14 || $[39] !== t15 || $[40] !== t8 || $[41] !== t9) {
    t16 = <button type="button" className={t8} onClick={t9} onMouseEnter={t10} onMouseLeave={t11}>{t12}{t13}{t14}{t15}</button>;
    $[34] = t10;
    $[35] = t11;
    $[36] = t12;
    $[37] = t13;
    $[38] = t14;
    $[39] = t15;
    $[40] = t8;
    $[41] = t9;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  return t16;
};
PDPFullWidthImageAndTextOption.propTypes = {
  content: PropTypes.shape({
    image: PropTypes.string,
    textTitle: PropTypes.string,
    text: PropTypes.string,
    price: PropTypes.string
  }),
  onClickAction: PropTypes.func,
  onHoverAction: PropTypes.func,
  valueId: PropTypes.number,
  sku: PropTypes.string,
  optionValueName: PropTypes.string,
  selectedId: PropTypes.number
};
export default PDPFullWidthImageAndTextOption;